module.exports = __webpack_public_path__ + "static/media/settings.15ce6df7.svg";